const faqData = [
  {
    q: '羞羞动漫在线观看需要注册或付费吗？',
    a: '完全不需要。羞羞动漫在线免费观看无需注册登录，打开网站即可直接浏览和播放全部蜜桃动漫在线资源，全程无任何收费项目。',
  },
  {
    q: '蜜桃动漫在线资源多久更新一次？',
    a: '我们坚持每日更新节奏，新番上线后48小时内同步更新到本站。羞羞动漫在线新番版块每周一发布当周更新清单，确保漫迷们第一时间追到最新剧集。',
  },
  {
    q: '羞羞动漫在线高清播放最高支持什么画质？',
    a: '本站羞羞动漫在线观看完整版系列最高支持1080P高清画质，根据您的网络状况自动适配最佳清晰度，确保流畅不卡顿的观看体验。',
  },
  {
    q: '手机端观看羞羞动漫在线体验如何？',
    a: '羞羞动漫在线全面适配移动端浏览器，采用下拉式流畅浏览设计，触屏操作顺滑自然。无论是iOS还是Android设备，打开浏览器即可享受与桌面端一致的蜜桃动漫在线观看体验。',
  },
  {
    q: '如何找到我想看的蜜桃动漫在线类型？',
    a: '您可以通过首页的专题合集按分类浏览，也可以使用热门话题标签快速筛选。校园恋爱、奇幻冒险、新番热映、经典重温等多维度分类，帮您快速定位心仪的羞羞动漫在线资源。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            关于羞羞动漫在线观看的常见疑问解答
          </p>
        </div>

        <div className="max-w-[800px] mx-auto space-y-4">
          {faqData.map((item, i) => (
            <div
              key={i}
              className="bg-background-100/60 rounded-xl border border-background-200/60 p-5 md:p-6"
            >
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-800 mb-3 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 text-xs font-bold mt-0.5">
                  Q
                </span>
                {item.q}
              </h3>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed pl-9">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}